import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { RegulatedProductService } from '../../regulated-products.service';
import {
  ICustomizedFormatUpdate,
  IHierarchyFormatUpdate,
  REGULATED_PRODUCT_TTL_ES
} from '../../regulated-product.interface';
import { UpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.template';
import { IUpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.interface';
import {
  getBasicFormatsNames,
  getCustomizedFormatNames
} from '../../utils/formats-handler.utils';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'pg-regulated-product-update',
  templateUrl: './regulated-products-update.component.html',
  providers: [MessageService]
})
export class RegulatedProductUpdateComponent
  extends UpdateTemplate
  implements IUpdateTemplate
{
  readyToUpdate = false;
  changeForm = false;
  select = {
    item: {
      type: 'single',
      openDialog: false,
      id: undefined,
      code: undefined,
      barCode: ''
    }
  };

  hasPurchaseFormat = false;
  hasMinSaleFormat = false;
  itemDigemid: { label: string; value: string }[];
  clonedHierarchyFormat: { [s: string]: IHierarchyFormatUpdate } = {};
  clonedCustomizedFormat: { [s: string]: ICustomizedFormatUpdate } = {};
  hierarchyFormats = [];
  statuses = [];
  nameList = [];
  hierarchyFormatLength = 0;
  customizedFormatLength = 0;
  details: any;
  saleFormatID: any;
  saleFormat: any;
  formatObj = {};
  length0fObject: number;
  subformatQuantity: number;
  disabled: boolean;
  i: number;
  enabledReload: boolean;
  activeEdit: boolean;
  constructor(
    private fb: FormBuilder,
    // private fg: FormBuilder,
    private regulatedProductService: RegulatedProductService,
    private messageService: MessageService
  ) {
    super(REGULATED_PRODUCT_TTL_ES, regulatedProductService);
  }

  ngOnInit() {
    this.enabledReload = true;
    this.activeEdit = false;
    this.disabled = true;
    const item = this.row;
    // console.log('item', item);
    this.fg = this.fb.group({
      item: [{ value: item.id, disabled: true }, [Validators.required]],
      barCode: [{ value: item.barCode, disabled: false }, []]
    });
    this.select.item.id = item.id;
    this.select.item.code = Number(item.code);
    this.select.item.barCode = item.barCode;
    this.details = item;
    this.setItemDetails();

    this.saleFormat = item.format;

    this.length0fObject = 0;
    this.subformatQuantity = 0;
    for (const key in item.format) {
      if (item.format[key].subFormat) {
        this.subformatQuantity++;
      }
      this.length0fObject++;
    }
    if (this.length0fObject == 1) {
      this.disabled = false;
    }

    if (this.length0fObject - 1 != this.subformatQuantity) {
      this.hierarchyFormats = [
        {
          id: 1,
          nombre: '',
          subFormat: '',
          quantitySubFormat: 1,
          isFormatSale: false,
          isFormatSaleMin: false,
          isFormatPurchase: false
        }
      ];
    } else {
      const basicFormatNames: string[] = getBasicFormatsNames(item.format);

      const customizedFormatNames: string[] = getCustomizedFormatNames(
        item.format,
        basicFormatNames
      );
      this.i = 1;
      for (const formatName of basicFormatNames) {
        const detailsElement = this.saleFormat[formatName];

        if (
          Object.prototype.hasOwnProperty.call(
            detailsElement,
            'isFormatSaleMin'
          ) &&
          detailsElement['isFormatSaleMin'] === true
        ) {
          this.hasMinSaleFormat = true;
        }

        if (
          Object.prototype.hasOwnProperty.call(
            detailsElement,
            'isFormatPurchase'
          ) &&
          detailsElement['isFormatPurchase'] === true
        ) {
          this.hasPurchaseFormat = true;
        }

        detailsElement['nombre'] = formatName;
        detailsElement['id'] = this.i++;

        this.hierarchyFormats.push(detailsElement);
      }

      for (const formatName of customizedFormatNames) {
        const detailsCustomElement = this.saleFormat[formatName];
        detailsCustomElement['nombre'] = formatName;
      }

      if (this.hierarchyFormats.length == 0) {
        this.hierarchyFormats = [
          {
            id: 1,
            nombre: '',
            subFormat: '',
            quantitySubFormat: 1,
            isFormatSale: false,
            isFormatSaleMin: false,
            isFormatPurchase: false
          }
        ];
      }
      this.hierarchyFormatLength = this.hierarchyFormats.length - 1;
    }
  }

  parseData() {
    const format = this.formatObj;
    const barCode = this.fg.value.barCode;
    if (barCode && barCode.length > 0) {
      return { format, barCode };
    }
    return { format };
  }

  onSelectedItem(row) {
    if (row) {
      this.select.item.id = row.id;
      this.details = row;
      this.setItemDetails();
    }
    this.select.item.openDialog = false;
  }

  onHierarchyRowEdit(product: IHierarchyFormatUpdate) {
    this.clonedHierarchyFormat[product.id] = { ...product };
  }

  onHierarchyRowEditSave(product: IHierarchyFormatUpdate) {
    if (this.hierarchyFormats[product.id]) {
      this.hierarchyFormats[product.id].nombre = product.subFormat;
    }
    delete this.clonedHierarchyFormat[product.id];
    this.checkEssentialFormatsExistence();
  }

  onHierarchyRowEditCancel(product: IHierarchyFormatUpdate, index: number) {
    this.hierarchyFormats[index] = this.clonedHierarchyFormat[product.id];
    delete this.clonedHierarchyFormat[product.id];
  }

  hierarchyAddRow(ri: number) {
    this.disabled = true;
    this.hierarchyFormats.push({
      id: ri + 2,
      nombre: this.hierarchyFormats[ri].subFormat,
      subFormat: '',
      quantitySubFormat: 1,
      isFormatSale: false,
      isFormatSaleMin: false,
      isFormatPurchase: false
    });
    this.hierarchyFormatLength = this.hierarchyFormats.length - 1;
    this.checkEssentialFormatsExistence();
  }
  hierarchyDeleteRow() {
    if (this.hierarchyFormats[this.hierarchyFormatLength - 1].id == 1) {
      this.disabled = false;
    } else {
      this.disabled = true;
    }
    this.hierarchyFormats.pop();
    this.hierarchyFormatLength = this.hierarchyFormats.length - 1;
    this.checkEssentialFormatsExistence();
  }

  cambiarCheck(ri) {
    for (let index = 0; index < this.hierarchyFormats.length; index++) {
      if (index !== ri) {
        this.hierarchyFormats[index].isFormatSaleMin = false;
      }
    }
    this.hierarchyFormats[ri].subFormat = null;
  }

  setNameList() {
    this.statuses = this.hierarchyFormats.map((format) => {
      return {
        label: format.nombre,
        value: format.nombre
      };
    });
  }

  setItemDetails() {
    const fieldsStock = {
      code: 'Código',
      name: 'Nombre',
      concentration: 'Concentración',
      form: 'form',
      formSimp: 'Símbolo',
      presentation: 'Presentación',
      laboratory: 'Laboratorio',
      fractions: 'Fracción'
    };
    const keysStock = Object.keys(fieldsStock);
    this.itemDigemid = keysStock.map((key) => {
      return {
        label: fieldsStock[key],
        value: this.details[key]
      };
    });
  }
  output() {
    const myObj = {};

    for (const key in this.hierarchyFormats) {
      const element = this.hierarchyFormats[key];
      if (
        element.nombre !== '' &&
        element.subFormat !== '' &&
        element.quantitySubFormat !== 0
      ) {
        myObj[element.nombre] = {
          subFormat: element.subFormat === null ? undefined : element.subFormat,
          quantitySubFormat: element.quantitySubFormat,
          isFormatSale: element.isFormatSale,
          isFormatSaleMin: element.isFormatSaleMin,
          isFormatPurchase: element.isFormatPurchase
        };
      }
    }

    this.formatObj = myObj;

    this.length0fObject = 0;

    for (const key in this.formatObj) {
      this.length0fObject++;
    }
    // if (this.length0fObject != this.hierarchyFormats.length) {
    //   return false;
    // }
    return true;
  }
  setReadyToUpdate() {
    this.readyToUpdate =
      this.select.item.id &&
      this.hierarchyFormats[0].nombre !== '' &&
      this.hierarchyFormats[0].subFormat !== '';
  }

  checkEssentialFormatsExistence() {
    this.hasPurchaseFormat = false;
    this.hasMinSaleFormat = false;

    for (const format of this.hierarchyFormats) {
      if (
        Object.prototype.hasOwnProperty.call(format, 'isFormatSaleMin') &&
        format['isFormatSaleMin'] === true
      ) {
        this.hasMinSaleFormat = true;
      }

      if (
        Object.prototype.hasOwnProperty.call(format, 'isFormatPurchase') &&
        format['isFormatPurchase'] === true
      ) {
        this.hasPurchaseFormat = true;
      }
    }
  }

  onSubmit() {
    this.setReadyToUpdate();
    if (this.output()) {
      if (this.readyToUpdate) {
        const generatedProduct = this.parseData();
        this.updateItem$(generatedProduct);
      }
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Campos Incompletos',
        detail: 'El Formato de Venta está incompleto'
      });
    }
  }
  reset() {
    this.enabledReload = false;
    this.activeEdit = true;
    delete this.hierarchyFormats;
    this.disabled = false;
    this.hierarchyFormatLength = 0;

    this.hierarchyFormats = [
      {
        id: 1,
        nombre: '',
        subFormat: '',
        quantitySubFormat: 1,
        isFormatSale: false,
        isFormatSaleMin: false,
        isFormatPurchase: true
      }
    ];
  }
  reload() {
    this.enabledReload = false;
    this.activeEdit = true;
  }
  ngOnDestroy() {
    if (this.activeEdit) {
      location.reload();
    }
  }
}
